import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { EncashedLeaveProcessColumns } from "../../tableColumns/table-columns";
import { EncashedLeaveProcessJson } from "../../DynamicFormsJson/Transaction/encashedLeaveProcess";
import { withRouter } from "../../components/withRouter";
import { compose } from "recompose";
import { getActiveSalesTeamByUserTypeIds } from "../../Slice/salesExecutive.slice";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class EncashedLeaveMain extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        if (navigator.onLine) {
            this.getData();
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    getData = async () => {
        const { getActiveSalesTeamByUserTypeIds, showLoador, showNotification } = this.props;

        let dataJson = {
            userTypeIds: [3, 4],
        }
        showLoador({ loador: true });
        await getActiveSalesTeamByUserTypeIds({ userTypeIdsData: dataJson }).then(({ response, success }) => {
            if (!success) {
                showNotification({
                    msg: serverMsg,
                    severity: "error",
                });
            }
        });
        showLoador({ loador: false });
    }

    rowTransfer = (rowData) => {
        this.props.navigate(EncashedLeaveProcessJson.openFormPathStatus + "/" + rowData.id);
    }

    render() {
        const { salesTeamList } = this.props;
        return (
            <>
                <DynamicMainScreen
                    callApi={false}
                    formPath={EncashedLeaveProcessJson.formPath}
                    screenTitle={EncashedLeaveProcessJson.screenTitle}
                    fieldMeta={EncashedLeaveProcessJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={EncashedLeaveProcessJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={EncashedLeaveProcessJson.pdfFileName}
                    excelFileName={EncashedLeaveProcessJson.excelFileName}
                    showAddButton={false}
                    tableColumnsToFilter={EncashedLeaveProcessJson.tableColumnsToFilter}
                    tableColumns={EncashedLeaveProcessColumns}
                    tableData={salesTeamList?.salesPersonByArea}
                    getTableData={this.getData}
                    apiBaseURL={EncashedLeaveProcessJson.apiBaseURL}
                    baseIdColumn={EncashedLeaveProcessJson.baseIdColumn}
                    showDeleteIcon={false}
                    showViewButtonInTable={true}
                    formPathView={EncashedLeaveProcessJson.formPathView}
                    isActiveURL={EncashedLeaveProcessJson.isActiveURL}
                    showEditIcon={false}
                    showTransferButtonInTable={true}
                    showTransferTitle={"Encashed Process"}
                    autoTransfer={false}
                    rowTransfer={this.rowTransfer}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    carryForwardLeaveList: state.year,
    salesTeamList: state.salesExecutive
});
const mapDispatchToProps = {
    getActiveSalesTeamByUserTypeIds,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(EncashedLeaveMain);
